var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-box" }, [
    _c(
      "div",
      { staticClass: "sidebar", on: { click: _vm.toggle } },
      [
        _c("app-icon", {
          staticClass: "icon-wechat",
          attrs: { type: "iconwechat" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display,
            expression: "display"
          }
        ],
        staticClass: "sidebar-info"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("app-icon", {
          staticClass: "icon-close",
          attrs: { type: "iconclose" },
          on: { click: _vm.toggle }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-info-item" }, [
      _c("div", { staticClass: "sidebar-qr" }, [
        _c("img", {
          attrs: {
            width: "90",
            height: "90",
            src:
              "https://sitecdn.zcycdn.com/zcy-front-other-upload/4894ac47563844d5df81ee7652e18a64.png?x-oss-process=image/quality,Q_75/format,jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("strong", [_vm._v("微信扫码关注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46eefe02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46eefe02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/index.vue
// module id = AHQD
// module chunks = 1 2